import initialState from './initialState';
import reducer from './reducer';

export default (state = initialState, action) => reducer(state, action);
